import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService } from 'src/services/login.service';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss'],
})
export class DialogComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private messageService: MessageService
  ) {
    setTimeout(function () {
      // window.print();
    }, 500);
    window.onfocus = function () {
      setTimeout(function () {
        // window.close();
      }, 500);
    };
    this.messageService.sendMessage('print');

    data.type = 'check_circle';
    // data.type == 'success' ? (data.type = 'check_circle') : data.type;
    console.log(data);
    // this.message;
  }

  ngOnInit(): void {
    console.log(window.location);
  }
}
